import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, Observable, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { CorporateService } from '@fcom/common/services/corporate/corporate.service';
import { NotificationTheme } from '@fcom/ui-components/components/notifications';
import { ToasterService } from '@fcom/common/services';
import { Company } from '@fcom/common/interfaces';

import { CompanyActions } from '../actions';
import { fetchCompany, setCompany } from '../actions/company.actions';

@Injectable()
export class CompanyEffects {
  constructor(
    private readonly actions$: Actions<CompanyActions.CompanyActionsUnion>,
    private corporateService: CorporateService,
    private toasterService: ToasterService
  ) {}

  loadCompanyDetails$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CompanyActions.fetchCompany),
        switchMap(() => this.corporateService.getCompanyDetails()),
        catchError((err: unknown) => this.handleApiError(err)),
        map((company: Company) => setCompany({ company }))
      );
    },
    { useEffectsErrorHandler: true }
  );

  updateCompanyDetails$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CompanyActions.updateCompany),
        exhaustMap(({ payload }) => this.corporateService.updateCompanyDetails(payload)),
        catchError((err: unknown) => this.handleApiError(err)),
        map(fetchCompany)
      );
    },
    { useEffectsErrorHandler: true }
  );

  updateContactPersons$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CompanyActions.updateContactPersons),
        exhaustMap(({ payload }) => this.corporateService.updateContactPersons(payload)),
        catchError((err: unknown) => this.handleApiError(err)),
        map(fetchCompany)
      );
    },
    { useEffectsErrorHandler: true }
  );

  private handleApiError(err: unknown): Observable<void> {
    this.toasterService.addMessageToQueue({
      id: 'company-request-error',
      contentKey: 'CORPORATE.corporatePortal.notifications.commonError',
      theme: NotificationTheme.ALERT,
      autoClose: true,
    });
    throw err;
  }
}
